import React, { ReactNode, MouseEventHandler } from "react";
import "./index.scss";

interface ButtonProps {
  type?: "button" | "submit" | "reset";
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  children: ReactNode;
  className?: string;
  variant?: "primary" | "secondary" | "danger" | "warning" | "success"; // Example variants, customize as needed
  btnRef?: any;
  [key: string]: any;
}

const Button: React.FC<ButtonProps> = ({
  type = "button",
  onClick,
  disabled,
  children,
  className = "",
  variant = "primary",
  btnRef,
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`btn ${className} ${disabled ? "disabled:opacity-70" : ""} ${variant}`}
      ref={btnRef ?? null}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
